var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { Card } from "@irati/ui/src/Layout";
import { H2 } from "@irati/ui/src/Headings";
import Expand from "@irati/ui/src/Expander";
import { DEVELOPMENT, LOCAL } from "@irati/utils/constants/environment";
import env from "@irati/utils/env";
import { Container } from "./styled";
var Oops = /** @class */ (function (_super) {
    __extends(Oops, _super);
    function Oops() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openExpander = function () {
            var caught = _this.props.caught;
            var autoShowFor = [LOCAL, DEVELOPMENT];
            if (caught && autoShowFor.includes(env.ENVIRONMENT_NAME)) {
                _this.expander.open();
            }
        };
        return _this;
    }
    Oops.prototype.componentDidMount = function () {
        this.openExpander();
    };
    Oops.prototype.componentDidUpdate = function () {
        this.openExpander();
    };
    Oops.prototype.render = function () {
        var _this = this;
        var caught = this.props.caught;
        return (React.createElement(Container, null,
            React.createElement(Card, null,
                React.createElement(H2, { large: true },
                    React.createElement(FormattedMessage, { id: "platform.oops.header.text" })),
                React.createElement(Expand, { ref: function (c) { _this.expander = c; }, title: "The tech stuff" },
                    React.createElement("pre", null, caught.stack)))));
    };
    Oops.defaultProps = {
        caught: null
    };
    return Oops;
}(Component));
export default Oops;
